import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=b2440c00&scoped=true&"
import script from "./Schedule.vue?vue&type=script&lang=ts&"
export * from "./Schedule.vue?vue&type=script&lang=ts&"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=b2440c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2440c00",
  null
  
)

export default component.exports